<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container" style="overflow: hidden">
      <div
        class="
          asc-page-heading-2
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            @click="gobackpointer"
            class="mr-3 pointer"
            src="../../assets/customfield/blueBackArrow.svg"
            alt=""
          />
          Search
        </div>
      </div>
      <div class="d-flex mt-2">
        <div style="width: 25%; padding-right: 10px">
          <div class="search-candidate-left-container">
            <div class="d-flex align-items-center justify-content-between pr-2">
              <div class="cv-bold-txt">Filters</div>
              <div @click="clearFilter" class="cv-clear-all-text pointer">
                Clear All
              </div>
            </div>
            <div class="cv-left-overflow">
              <div class="mt-3 position-relative">
                <div
                  :class="
                    search.activeInDays ? 'cp-blue-reg-txt' : 'acs-input-head'
                  "
                >
                  Active in
                </div>
                <SelectDropdown
                  :placeholder="'Select'"
                  :disableDropdown="isViewing"
                  :dropdownOptions="toDropdownOptions(ACTIVE_IN)"
                  :value="
                    search.activeInDays ? search.activeInDays.toString() : ''
                  "
                  :text="ACTIVE_IN[search.activeInDays]"
                  @setValue="search.activeInDays = $event"
                />
              </div>
              <div class="mt-3 position-relative">
                <div
                  :class="
                    search.viewProfile ? 'cp-blue-reg-txt' : 'acs-input-head'
                  "
                >
                  View Profile
                </div>
                <SelectDropdown
                  :placeholder="'Select'"
                  :disableDropdown="isViewing"
                  :dropdownOptions="toDropdownOptions(VIEW_PROFILE)"
                  :value="search.viewProfile"
                  :text="VIEW_PROFILE[search.viewProfile]"
                  @setValue="search.viewProfile = $event"
                />
              </div>
              <div class="mt-3">
                <div class="cv-field panellist-tags" @click.stop="">
                  <div
                    class="
                      d-flex
                      justify-content-between
                      position-relative
                      pointer
                      user-select-none
                    "
                    :class="
                      search.keywords.length
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="showField['keywords'] = !showField['keywords']"
                  >
                    <div>Keywords</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['keywords']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <div
                    :class="
                      isViewing ? 'cs-laptopinput-disable' : 'cs-laptopinput'
                    "
                    class="mt-1"
                    v-if="showField['keywords']"
                  >
                    <div class="d-flex flex-nowrap custom-cv-tags">
                      <div class="d-flex flex-nowrap">
                        <div
                          v-for="(keyword, index) in search.keywords"
                          :key="index"
                          :class="isViewing ? 'cv-greytag' : 'cv-bluetag w-100'"
                        >
                          <template v-if="isViewing">
                            <img
                              v-if="search.mandatoryKeywords.includes(keyword)"
                              src="../../assets/cvsearch/greyfilledstar.svg"
                              alt=""
                            />
                            <img
                              v-else
                              src="../../assets/cvsearch/greyEmptystar.svg"
                              alt=""
                            />

                            <span class="ml-1 mr-1">{{ keyword }}</span>
                          </template>
                          <template v-else>
                            <div style="width: 15px">
                              <img
                                class="pointer"
                                v-if="
                                  search.mandatoryKeywords.includes(keyword)
                                "
                                src="../../assets/cvsearch/filledstar.svg"
                                alt=""
                                @click="removeMandatoryKeyword(keyword)"
                              />
                              <img
                                class="pointer"
                                v-else
                                src="../../assets/cvsearch/emptystar.svg"
                                alt=""
                                @click="addMandatoryKeyword(keyword)"
                              />
                            </div>

                            <div
                              class="ml-2 mr-2 text-truncate"
                              style="
                                min-width: auto;
                                max-width: 290px !important;
                              "
                            >
                              {{ keyword }}
                            </div>
                            <div>
                              <img
                                class="pointer"
                                src="../../assets/cvsearch/bluetagcross.svg"
                                alt=""
                                @click="removeKeyword(index)"
                              />
                            </div>
                          </template>
                        </div>
                      </div>
                      <b-form-input
                        class="pl-0"
                        placeholder="Enter"
                        v-if="!isViewing"
                        v-model="currentKeyword"
                        @keydown="addKeyword"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="cv-small-grey mt-1" v-if="showField['keywords']">
                  {{
                    search.keywords.length
                      ? "Click on star to make it as mandatory skill"
                      : 'Press "Enter" to add keywords'
                  }}
                </div>
                <div
                  class="position-relative cv-small-grey mt-2"
                  :class="!isViewing && 'pointer user-select-none'"
                  ref="resumeTitleBtn"
                  v-if="showField['keywords']"
                >
                  <div
                    @click="
                      !isViewing && (showKeywordDropdown = !showKeywordDropdown)
                    "
                  >
                    Search Keyword in
                    <span
                      :class="isViewing ? 'cv-small-grey' : 'cv-small-blue'"
                    >
                      {{ SEARCH_TYPES[search.searchType] }}
                    </span>
                    <img
                      class="ml-1"
                      src="../../assets/cvsearch/bluesmallarrow.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="btns-stckd resumeTitle-parent right-72px"
                    v-if="showKeywordDropdown"
                    ref="resumeTitleDropDown"
                    v-closable="{
                      exclude: ['resumeTitleDropDown', 'resumeTitleBtn'],
                      handler: 'hideKeywordDropdown',
                    }"
                  >
                    <b-form-radio-group
                      v-model="search.searchType"
                      :options="toDropdownOptions(SEARCH_TYPES)"
                      @change="showKeywordDropdown = false"
                      text-field="text"
                      value-field="value"
                      buttons
                      stacked
                      name="radio-stacked"
                    >
                    </b-form-radio-group>
                  </div>
                </div>
              </div>
              <div
                class="position-relative"
                :class="showField['keywords'] ? 'mt-2' : 'mt-3'"
              >
                <div
                  class="
                    d-flex
                    justify-content-between
                    position-relative
                    pointer
                    user-select-none
                  "
                  :class="
                    search.experienceTo || search.experienceFrom
                      ? 'cp-blue-reg-txt'
                      : 'acs-input-head'
                  "
                  @click="showField['experience'] = !showField['experience']"
                >
                  <div>Experience</div>
                  <div>
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['experience']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div
                  class="d-flex align-items-center mt-1 pr-4"
                  v-if="showField['experience']"
                >
                  <div class="">
                    <b-form-input
                      :disabled="isViewing"
                      class="cs-laptopinput no-spinner"
                      placeholder="Enter"
                      v-model="search.experienceFrom"
                      type="text"
                      @keypress="preventKeys($event, ['e', '+', '-'])"
                    ></b-form-input>
                  </div>
                  <div class="cv-grey-txt ml-2 mr-2">to</div>
                  <div class="position-relative">
                    <div class="d-flex align-items-center">
                      <div>
                        <b-form-input
                          :disabled="isViewing"
                          class="cs-laptopinput no-spinner"
                          :class="{ error: !$v.search.experienceTo.greater }"
                          placeholder="Enter"
                          v-model="$v.search.experienceTo.$model"
                          type="text"
                          @keypress="preventKeys($event, ['e', '+', '-'])"
                        ></b-form-input>
                      </div>
                      <div class="cv-grey-txt ml-2">Years</div>
                    </div>
                    <div
                      class="errortxt position-absolute"
                      v-if="!$v.search.experienceTo.greater"
                    >
                      Should be more than {{ search.experienceFrom }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div
                  class="
                    d-flex
                    justify-content-between
                    position-relative
                    pointer
                    user-select-none
                  "
                  :class="
                    search.salaryFrom || search.salaryTo
                      ? 'cp-blue-reg-txt'
                      : 'acs-input-head'
                  "
                  @click="showField['ctc'] = !showField['ctc']"
                >
                  <div>Annual CTC</div>
                  <div>
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['ctc']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div
                  class="d-flex align-items-center mt-1 pr-4"
                  v-if="showField['ctc']"
                >
                  <div class="">
                    <b-form-input
                      :disabled="isViewing"
                      class="cs-laptopinput no-spinner"
                      placeholder="Enter"
                      v-model="search.salaryFrom"
                      type="text"
                      @keypress="preventKeys($event, ['e', '+', '-'])"
                    ></b-form-input>
                  </div>
                  <div class="cv-grey-txt ml-2 mr-2">to</div>

                  <div class="position-relative">
                    <div class="d-flex align-items-center">
                      <div class="pr-2">
                        <b-form-input
                          :disabled="isViewing"
                          class="cs-laptopinput no-spinner"
                          :class="{ error: !$v.search.salaryTo.greater }"
                          placeholder="Enter"
                          v-model="$v.search.salaryTo.$model"
                          type="text"
                          @keypress="preventKeys($event, ['e', '+', '-'])"
                        ></b-form-input>
                      </div>
                      <div class="cv-grey-txt">LPA</div>
                    </div>
                    <div
                      class="errortxt position-absolute"
                      v-if="!$v.search.salaryTo.greater"
                    >
                      Should be more than {{ search.salaryFrom }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div
                  class="
                    d-flex
                    justify-content-between
                    position-relative
                    pointer
                    user-select-none
                  "
                  :class="
                    search.location.length || search.preferredLocation.length
                      ? 'cp-blue-reg-txt'
                      : 'acs-input-head'
                  "
                  @click="showField['location'] = !showField['location']"
                >
                  <div>Location</div>
                  <div class="pointer">
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['location']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div
                  class="topDiv cv-field panellist-tags"
                  @click.stop=""
                  v-if="showField['location']"
                >
                  <div
                    class="
                      acs-input-head
                      d-flex
                      justify-content-between
                      position-relative
                      mt-2
                    "
                  >
                    <div>Current Location</div>
                  </div>
                  <b-form-tags
                    :disabled="isViewing"
                    class="text-truncate cv-input-pan w-100 mt-1"
                    :placeholder="isViewing ? '' : 'Enter'"
                    type="text"
                    remove-on-delete
                    duplicate-tag-text=""
                    v-model="search.location"
                  ></b-form-tags>
                  <div class="pff-checkbox mt-1" v-if="showField['location']">
                    <b-form-checkbox
                      size="sm"
                      :disabled="isViewing"
                      v-model="search.willingToRelocate"
                      @change="
                        search.preferredLocation.splice(
                          0,
                          search.preferredLocation.length
                        )
                      "
                      >Willing to relocate</b-form-checkbox
                    >
                  </div>
                </div>
                <div
                  class="topDiv cv-field panellist-tags"
                  @click.stop=""
                  v-if="showField['location']"
                >
                  <div
                    class="
                      acs-input-head
                      d-flex
                      justify-content-between
                      position-relative
                      mt-2
                    "
                  >
                    <div>Preferred Location</div>
                  </div>
                  <b-form-tags
                    :key="search.willingToRelocate"
                    class="text-truncate cv-input-pan w-100 mt-1"
                    :placeholder="isViewing ? '' : 'Enter'"
                    type="text"
                    :disabled="isViewing || !search.willingToRelocate"
                    duplicate-tag-text=""
                    v-model="search.preferredLocation"
                    remove-on-delete
                  ></b-form-tags>
                  <div class="cv-small-grey mt-1">
                    Press "Enter" to add Preferred Location
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div
                  class="position-relative pointer user-select-none"
                  :class="
                    search.noticePeriod ? 'cp-blue-reg-txt' : 'acs-input-head'
                  "
                  @click="
                    showField['noticePeriod'] = !showField['noticePeriod']
                  "
                >
                  <div>Notice period / Availability to Join</div>
                  <div>
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['noticePeriod']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div
                  class="mt-1 d-flex flex-wrap"
                  v-if="showField['noticePeriod']"
                >
                  <div
                    v-for="(period, key) in NOTICE_PERIODS"
                    :key="key"
                    :class="[
                      search.noticePeriod === key
                        ? isViewing
                          ? 'cv-notice-period-tags-sel-dis'
                          : 'cv-notice-period-tags-sel'
                        : 'cv-notice-period-tags',
                      !isViewing && 'pointer',
                    ]"
                    class="mr-2 mb-1"
                    @click="!isViewing && toggleNoticePeriod(key)"
                  >
                    {{ period }}
                  </div>
                </div>
              </div>
              <!-- <div class="topDiv cv-field panellist-tags mt-3" @click.stop="">
                <div
                  class="position-relative pointer user-select-none"
                  :class="
                    search.gender.length ? 'cp-blue-reg-txt' : 'acs-input-head'
                  "
                  @click="showField['gender'] = !showField['gender']"
                >
                  <div>Gender</div>
                  <div>
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['gender']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <MultiSelectSearch
                  label="Gender"
                  :options="toDropdownOptions(GENDERS)"
                  :selected="search.gender"
                  @select-value="search.gender = $event"
                  v-if="showField['gender']"
                />
              </div> -->
              <div class="mt-3">
                <div
                  class="position-relative pointer user-select-none"
                  :class="
                    search.ageFrom || search.ageTo
                      ? 'cp-blue-reg-txt'
                      : 'acs-input-head'
                  "
                  @click="showField['age'] = !showField['age']"
                >
                  <div>Candidate Age</div>
                  <div>
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-downarrow.svg"
                      alt=""
                      v-if="!showField['age']"
                    />
                    <img
                      class="cv-arrow-pos"
                      src="../../assets/cvsearch/cv-uparrow.svg"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div
                  class="d-flex align-items-center mt-1 pr-4"
                  v-if="showField['age']"
                >
                  <div class="">
                    <b-form-input
                      class="cs-laptopinput no-spinner"
                      :placeholder="isViewing ? '' : 'Enter'"
                      :disabled="isViewing"
                      v-model="search.ageFrom"
                      type="text"
                      @keypress="preventKeys($event, ['e', '+', '-', '.'])"
                    ></b-form-input>
                  </div>
                  <div class="cv-grey-txt ml-2 mr-2">to</div>

                  <div class="position-relative">
                    <div class="d-flex align-items-center">
                      <div class="">
                        <b-form-input
                          class="cs-laptopinput no-spinner"
                          :class="{ error: !$v.search.ageTo.greater }"
                          :placeholder="isViewing ? '' : 'Enter'"
                          :disabled="isViewing"
                          v-model="$v.search.ageTo.$model"
                          type="text"
                          @keypress="preventKeys($event, ['e', '+', '-', '.'])"
                        ></b-form-input>
                      </div>
                      <div class="cv-grey-txt ml-2">Years</div>
                    </div>
                    <div
                      class="errortxt position-absolute"
                      v-if="!$v.search.ageTo.greater"
                    >
                      Should be more than {{ search.ageFrom }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div class="topDiv cv-field panellist-tags" @click.stop="">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.workType.length
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="showField['workType'] = !showField['workType']"
                  >
                    <div>Work Type</div>
                    <div class="pointer">
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['workType']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <MultiSelectSearch
                    label="Work Type"
                    :options="toDropdownOptions(WORK_TYPE)"
                    :selected="search.workType"
                    @select-value="search.workType = $event"
                    v-if="showField['workType']"
                  />
                </div>
              </div>
              <div class="mt-3 topDiv">
                <div class="topDiv cv-field panellist-tags" @click.stop="">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.employmentType.length
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="
                      showField['employmentType'] = !showField['employmentType']
                    "
                  >
                    <div>Job type</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['employmentType']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <MultiSelectSearch
                    label="Job Type"
                    :options="toDropdownOptions(EMPLOYMENT_TYPE)"
                    :selected="search.employmentType"
                    @select-value="search.employmentType = $event"
                    v-if="showField['employmentType']"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center mt-3">
                <div @click="showAdvanced = !showAdvanced" class="pointer">
                  <img
                    v-if="showAdvanced"
                    src="../../assets/customfield/modalTopArrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/customfield/modalDownArrow.svg"
                    alt=""
                  />
                </div>
                <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
                <div class="modal-horizontal-line"></div>
              </div>
              <b-collapse v-model="showAdvanced">
                <div class="mt-3">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.itSkills[0] && search.itSkills[0].skillName
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="showField['itSkills'] = !showField['itSkills']"
                  >
                    <div>IT Skills</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['itSkills']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <div v-if="showField['itSkills']">
                    <div
                      class="d-flex mt-1 pr-12"
                      :key="index"
                      v-for="(skill, index) in search.itSkills"
                    >
                      <div class="w-45 mr-3 position-relative">
                        <b-form-input
                          class="cs-laptopinput pl-32px"
                          placeholder="Enter skill name"
                          v-model="skill.skillName"
                          :disabled="isViewing"
                        ></b-form-input>
                        <template v-if="isViewing">
                          <img
                            v-if="skill.mandatory"
                            class="cv-star-skill-pos"
                            src="../../assets/cvsearch/greyfilledstar.svg"
                            alt=""
                          />
                          <img
                            v-else
                            class="cv-star-skill-pos"
                            src="../../assets/cvsearch/greyEmptystar.svg"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img
                            v-if="skill.mandatory"
                            class="cv-star-skill-pos"
                            src="../../assets/cvsearch/filledstar.svg"
                            alt=""
                            @click="skill.mandatory = false"
                          />
                          <img
                            v-else
                            class="cv-star-skill-pos"
                            src="../../assets/cvsearch/emptystar.svg"
                            alt=""
                            @click="skill.mandatory = true"
                          />
                        </template>
                      </div>
                      <div class="d-flex align-items-center">
                        <b-form-input
                          class="cs-laptopinput no-spinner"
                          :placeholder="
                            isViewing ? '' : 'Enter experience in years'
                          "
                          v-model="skill.yearsOfExp"
                          :disabled="isViewing"
                          type="text"
                          @keypress="preventKeys($event, ['e', '+', '-'])"
                        ></b-form-input>
                        <img
                          v-if="isViewing || search.itSkills.length === 1"
                          class="ml-2 pointer"
                          src="../../assets/cvsearch/removeskill.svg"
                          alt=""
                        />
                        <img
                          v-else
                          class="ml-2 pointer"
                          src="../../assets/cvsearch/removeskill.svg"
                          alt=""
                          @click="
                            !isViewing && search.itSkills.splice(index, 1)
                          "
                        />
                      </div>
                    </div>
                    <div class="cv-small-grey d-flex align-items-center mt-2">
                      <div
                        @click="
                          !isViewing &&
                            search.itSkills.push({
                              skillName: '',
                              yearsOfExp: '',
                              mandatory: false,
                            })
                        "
                        :class="isViewing ? '' : 'pointer'"
                      >
                        <img
                          class="mr-1"
                          src="../../assets/cvsearch/bluePlus.svg"
                          alt=""
                        />Add another IT Skill
                      </div>
                    </div>
                  </div>
                </div>
                <div class="topDiv cv-field panellist-tags mt-3" @click.stop="">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.industry.length
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="showField['industry'] = !showField['industry']"
                  >
                    <div>Industry</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['industry']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <div class="position-relative mt-1">
                    <b-form-tags
                      class="text-truncate cv-input-pan w-100"
                      :placeholder="isViewing ? '' : 'Enter'"
                      type="text"
                      remove-on-delete
                      :disabled="isViewing"
                      duplicate-tag-text=""
                      v-model="search.industry"
                      v-if="showField['industry']"
                    ></b-form-tags>
                  </div>
                </div>
                <div class="topDiv cv-field panellist-tags mt-3" @click.stop="">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.designation.length
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="
                      showField['designation'] = !showField['designation']
                    "
                  >
                    <div>Designation</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['designation']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <div class="position-relative mt-1">
                    <b-form-tags
                      class="text-truncate cv-input-pan w-100"
                      :placeholder="isViewing ? '' : 'Enter'"
                      type="text"
                      remove-on-delete
                      :disabled="isViewing"
                      duplicate-tag-text=""
                      v-model="search.designation"
                      v-if="showField['designation']"
                    ></b-form-tags>
                  </div>
                </div>
                <div class="mt-3 position-relative">
                  <div
                    class="position-relative pointer user-select-none"
                    :class="
                      search.minimumEducation
                        ? 'cp-blue-reg-txt'
                        : 'acs-input-head'
                    "
                    @click="showField['education'] = !showField['education']"
                  >
                    <div>Min. Education</div>
                    <div>
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-downarrow.svg"
                        alt=""
                        v-if="!showField['education']"
                      />
                      <img
                        class="cv-arrow-pos"
                        src="../../assets/cvsearch/cv-uparrow.svg"
                        alt=""
                        v-else
                      />
                    </div>
                  </div>
                  <SelectDropdown
                    :placeholder="'Select'"
                    :disableDropdown="isViewing"
                    :dropdownOptions="toDropdownOptions(EDUCATION)"
                    :value="search.minimumEducation"
                    :text="EDUCATION[search.minimumEducation]"
                    @setValue="search.minimumEducation = $event"
                    v-if="showField['education']"
                  />
                </div>
              </b-collapse>
            </div>
            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                border-top
                p-2
                bluebtn
                mt-2
              "
            >
              <b-button
                class="acs-cancelBtn-modal mt-1"
                @click="
                  search.searchID
                    ? updateSearch()
                    : $bvModal.show('save-search')
                "
                :disabled="
                  (search.searchID && isSearchSaved) || $v.search.$invalid
                "
              >
                {{ search.searchID ? "Update" : "Save" }}
              </b-button>
              <b-button
                class="acs-addBtn-modal ml-3 mt-1"
                :disabled="$v.search.$invalid || isSearchApplied"
                @click="
                  currentPage === 1 ? searchProfiles() : (currentPage = 1)
                "
                >Apply</b-button
              >
            </div>
          </div>
        </div>
        <div class="search-candidate-right-container">
          <template v-if="profiles.length == 0 && !loaderStatus">
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                align-items-center
                h-100
              "
            >
              <img
                src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                alt=""
                srcset=""
              />
              <div
                v-if="searchQuery !== ''"
                class="mt-2 text-center access-font-color w-75 text-break"
              >
                No matching results for "{{ searchQuery }}"
              </div>
              <div
                v-else
                class="mt-2 text-center access-font-color w-75 text-break"
              >
                No matching results
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                cv-right-header
              "
            >
              <div>
                <div class="cv-black-txt">
                  You Have {{ total || 0 }} Candidate(s) Matching with this
                  Search.
                </div>
              </div>

              <div class="d-flex align-items-center">
                <div class="bluebtn position-relative d-flex">
                  <b-button
                    ref="addDropdownBtn"
                    class="acs-addBtn mr-3"
                    @click="showAddDropdown = !showAddDropdown"
                    :disabled="selectCand.length == 0"
                  >
                    <img
                      src="../../assets/img/accessconnew/whitePlus.svg"
                      alt
                      class="mr-2"
                    />
                    <span class>Add</span>
                    <img
                      class="ml-2"
                      src="../../assets/whitedownarr.svg"
                      alt=""
                    />
                  </b-button>
                  <div
                    ref="addDropdown"
                    v-if="showAddDropdown"
                    class="cv-add-dropdown pointer"
                    v-closable="{
                      exclude: ['addDropdown', 'addDropdownBtn'],
                      handler: 'hideAddDropdown',
                    }"
                  >
                    <div
                      v-if="roles.includes('ADD_TO_JD')"
                      class="d-flex align-items-center landpage-unsel"
                      @click="showJobModal"
                    >
                      <img
                        src="../../assets/cvsearch/addtojob.svg"
                        alt
                        class="mr-2"
                      />
                      Add to Job
                    </div>
                    <div
                      class="d-flex align-items-center landpage-unsel"
                      @click="goToAddToTalentPool"
                    >
                      <img
                        src="../../assets/cvsearch/addtoTP.svg"
                        alt
                        class="mr-2"
                      />
                      Add to Talent Pool
                    </div>
                  </div>
                  <b-button
                    @click="goToBookmarked"
                    class="acs-addBtn w-140px mr-2"
                  >
                    <img
                      src="../../assets/cvsearch/whitebookmark.svg"
                      alt
                      class="mr-2"
                    />
                    <span class>Candidates</span>
                  </b-button>
                </div>
                <div class="d-flex switchtext mr-2 pointer">
                  <div class="d-flex switchParent ml-2">
                    <div
                      v-b-popover.hover.top="'Grid View'"
                      class="switchChild"
                      :class="{
                        activeSwitchLeft: !list,
                        notActiveSwitchLeft: list,
                      }"
                      @click="list = false"
                    >
                      <img
                        v-if="list == false"
                        src="../../assets/img/cvsearch/filtersorticon.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/cvsearch/gridnonsel.svg"
                        alt=""
                      />
                    </div>
                    <div
                      v-b-popover.hover.top="'List View'"
                      class="switchChild"
                      :class="{
                        activeSwitchRight: list,
                        notActiveSwitchRight: !list,
                      }"
                      @click="list = true"
                    >
                      <img
                        v-if="list != false"
                        src="../../assets/img/cvsearch/rightfilterwhite.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/cvsearch/listnonsel.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-2 cv-right-overflow" id="profiles-container">
              <b-row>
                <b-col
                  v-for="(profile, i) in profiles"
                  :key="i"
                  :cols="list ? '12' : '6'"
                  :class="i % 2 == 1 && !list ? 'pl-0' : ''"
                >
                  <div class="cv-new-card m-1">
                    <div class="border-bottom cv-top-card">
                      <div class="d-flex justify-content-between">
                        <div
                          class="d-flex align-items-center"
                          :class="list ? 'w-50' : 'w-80'"
                        >
                          <div class="common-single-checkbox mr-1">
                            <b-form-checkbox
                              :value="profile.userID"
                              v-model="selectCand"
                            ></b-form-checkbox>
                          </div>
                          <div class="cv-profile-img">
                            <img
                              class="h-100 w-100"
                              :src="profile.image"
                              alt="Profile Image"
                            />
                          </div>
                          <div class="ml-2 w-60">
                            <div
                              :class="list ? 'w-100' : 'w-95'"
                              class="cv-name-txt text-truncate"
                            >
                              {{ profile.firstName }} {{ profile.middleName }}
                              {{ profile.lastName }}
                            </div>
                            <div class="cv-desig-txt mt-1">
                              {{ profile.designation }}
                            </div>
                          </div>
                        </div>
                        <div
                          :class="list ? 'w-50 pl-4' : ''"
                          class="d-flex justify-content-between"
                        >
                          <div
                            v-if="list == true"
                            class="d-flex align-items-baseline"
                          >
                            <div class="d-flex align-items-center mr-4">
                              <img
                                class="mr-2"
                                src="../../assets/cvsearch/experience.svg"
                                alt=""
                              /><span class="cv-desig-txt">{{
                                formatExperience(profile.totalYearsOfExp)
                              }}</span>
                            </div>
                            <div class="d-flex align-items-center mr-4">
                              <img
                                class="mr-2"
                                src="../../assets/cvsearch/package.svg"
                                alt=""
                              />
                              <div>
                                <div class="cv-desig-txt">
                                  {{
                                    profile.expectedCTC
                                      ? `${profile.expectedCTC} LPA`
                                      : "NA"
                                  }}
                                </div>
                                <div class="cv-light-txt">(Expected)</div>
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <img
                                class="mr-2"
                                src="../../assets/cvsearch/location.svg"
                                alt=""
                              />
                              <div>
                                <div class="cv-desig-txt">
                                  {{ profile.willingToRelocateTo[0] || "NA" }}
                                </div>
                                <div class="cv-light-txt">(Preferred)</div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex flex-column align-items-end">
                            <div class="d-flex">
                              <div
                                class="
                                  d-flex
                                  cv-icon-container
                                  mr-2
                                  position-relative
                                  pointer
                                "
                                tabindex="0"
                                @focusout="hideCopyToClipboardOnFocusOut"
                              >
                                <img
                                  src="../../assets/cvsearch/call.svg"
                                  alt=""
                                  @click="toggleContactDropdown(profile.userID)"
                                  v-b-tooltip.hover="'Contact'"
                                />
                                <div
                                  v-if="
                                    currentContactDropdown === profile.userID
                                  "
                                  class="cv-tooltip"
                                >
                                  <div
                                    class="
                                      d-flex
                                      align-items-center
                                      justify-content-between
                                    "
                                  >
                                    <div class="mr-4">
                                      {{ profile.phoneNumber }}
                                    </div>
                                    <div>
                                      <img
                                        v-if="isCopied === 'phone'"
                                        class="pointer"
                                        src="../../assets/cvsearch/tick.svg"
                                        alt=""
                                      />
                                      <img
                                        v-else
                                        class="pointer"
                                        src="../../assets/cvsearch/copy.svg"
                                        alt=""
                                        @click="
                                          (isCopied = 'phone'),
                                            copyToClipboard(profile.phoneNumber)
                                        "
                                      />
                                    </div>
                                  </div>
                                  <div
                                    class="
                                      mt-2
                                      d-flex
                                      align-items-center
                                      justify-content-between
                                    "
                                  >
                                    <div class="mr-4">
                                      {{ profile.email }}
                                    </div>
                                    <div>
                                      <img
                                        v-if="isCopied === 'email'"
                                        class="pointer"
                                        src="../../assets/cvsearch/tick.svg"
                                        alt=""
                                      />
                                      <img
                                        v-else
                                        class="pointer"
                                        src="../../assets/cvsearch/copy.svg"
                                        alt=""
                                        @click="
                                          (isCopied = 'email'),
                                            copyToClipboard(profile.email)
                                        "
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="roles.includes('GET_PROFILE')"
                                @click="viewProfile(profile)"
                                class="d-flex cv-icon-container mr-2 pointer"
                              >
                                <img
                                  src="../../assets/cvsearch/view.svg"
                                  alt=""
                                  v-b-tooltip.hover="'View'"
                                />
                              </div>
                              <div
                                class="d-flex cv-icon-container pointer"
                                @click="bookmark(profile)"
                              >
                                <img
                                  v-if="profile.bookmark === true"
                                  src="../../assets/cvsearch/filledBookmark.svg"
                                  alt=""
                                  v-b-tooltip.hover="'Remove Bookmark'"
                                />
                                <img
                                  v-else
                                  src="../../assets/cvsearch/Bookmark.svg"
                                  alt=""
                                  v-b-tooltip.hover="'Bookmark'"
                                />
                              </div>
                            </div>

                            <div class="cv-view-tag mt-2" v-if="profile.viewed">
                              Viewed
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="list == false"
                        class="
                          d-flex
                          align-items-baseline
                          justify-content-between
                          mt-1
                          pl-2
                        "
                      >
                        <div class="d-flex align-items-center mr-4">
                          <img
                            class="mr-2"
                            src="../../assets/cvsearch/experience.svg"
                            alt=""
                          /><span class="cv-desig-txt">
                            {{ formatExperience(profile.totalYearsOfExp) }}
                          </span>
                        </div>
                        <div class="d-flex align-items-center mr-4">
                          <img
                            class="mr-2"
                            src="../../assets/cvsearch/package.svg"
                            alt=""
                          />
                          <div>
                            <div class="cv-desig-txt">
                              {{
                                profile.expectedCTC
                                  ? `${profile.expectedCTC} LPA`
                                  : "NA"
                              }}
                            </div>
                            <div class="cv-light-txt">(Expected)</div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <img
                            class="mr-2"
                            src="../../assets/cvsearch/location.svg"
                            alt=""
                          />
                          <div>
                            <div class="cv-desig-txt">
                              {{ profile.willingToRelocateTo[0] || "NA" }}
                            </div>
                            <div class="cv-light-txt">(Preferred)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap w-100">
                      <div
                        class="mt-1 mb-2 d-flex align-items-center pl-4"
                        :class="list ? 'w-49' : 'w-100'"
                      >
                        <div
                          class="d-flex align-items-center cv-desig-txt-2 w-30"
                        >
                          <img
                            class="mr-2"
                            src="../../assets/cvsearch/education.svg"
                            alt=""
                          />Education
                        </div>
                        <div class="w-65 cv-desig-txt">
                          <span
                            v-b-tooltip.hover.top="
                              formatEducation(profile.educationalInfo[0])
                            "
                            class="
                              text-truncate
                              d-inline-block
                              tooltip-width-fix
                            "
                            >{{
                              formatEducation(profile.educationalInfo[0])
                            }}</span
                          >
                        </div>
                      </div>
                      <div v-if="list == true" class="cv-vertical-line"></div>
                      <div
                        class="mt-1 mb-2 d-flex align-items-center pl-4"
                        :class="list ? 'w-49' : 'w-100'"
                      >
                        <div
                          class="d-flex align-items-center cv-desig-txt-2"
                          :class="list ? 'w-25' : 'w-30'"
                        >
                          <img
                            class="mr-6px"
                            src="../../assets/cvsearch/skills.svg"
                            alt=""
                          />Skills
                        </div>
                        <div class="w-65 text-truncate cv-desig-txt">
                          <span
                            v-b-tooltip.hover.top="
                              profile.skillsArray.join(', ')
                            "
                            class="
                              text-truncate
                              d-inline-block
                              tooltip-width-fix
                            "
                            >{{
                              profile.skillsArray.length == 0
                                ? "NA"
                                : profile.skillsArray.join(", ")
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div
              class="
                acs-paginaTion-new
                d-flex
                justify-content-between
                align-items-center
              "
              v-if="total > 0"
            >
              <div class="d-flex" style="width: 300px">
                <span class="acs-gotopage-text mr-2 p-1">Go to page</span>
                <b-form-input
                  type="text"
                  class="acs-pagination-num"
                  v-model="goToPage"
                  @keyup.enter="
                    goToPage == null || goToPage == '' || !iscontainsNumber
                      ? ''
                      : goToPages()
                  "
                  @keypress="NumbersOnly"
                  @paste="handlePaste"
                >
                </b-form-input>
                <div class="acs-pagination-addbtn">
                  <span
                    :class="
                      goToPage == null || goToPage == '' || !iscontainsNumber
                        ? 'disableDeleteIcon pl-3 mt-1'
                        : 'pointer pl-3 mt-1'
                    "
                  >
                    <img
                      @click="
                        goToPage == null || goToPage == '' || !iscontainsNumber
                          ? ''
                          : goToPages()
                      "
                      src="../../assets/panelist/page_arrow.svg"
                      alt
                    />
                  </span>
                </div>
              </div>
              <div
                style="width: 50%"
                class="d-flex justify-content-center pagination"
              >
                <b-pagination
                  :total-rows="total"
                  :per-page="pageCount"
                  v-model="currentPage"
                  @input="searchProfiles"
                  align="center"
                  first-number
                  last-number
                >
                  <template #prev-text
                    ><span
                      ><img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt=""
                      /> </span
                  ></template>
                  <template #next-text
                    ><span
                      ><img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt="" /></span
                  ></template>
                </b-pagination>
              </div>
              <div
                class="d-flex align-items-center justify-content-end"
                style="width: 570px"
              >
                <PageInput
                  :pagecount="pageCount"
                  @update-value="updatePageCount"
                />
                <div
                  class="
                    acs-gotopage-text
                    mr-2
                    ml-4
                    d-flex
                    align-items-center
                    justify-content-end
                  "
                >
                  Results : <span class="ml-1" v-if="pageStart > total">0</span
                  ><span v-else class="ml-1">{{ pageStart }}</span>
                  <span class="ml-1"> - {{ pageEnd }} </span>
                  <span class="pl-1"></span> of <span class="pr-1"></span
                  >{{ total }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <b-modal id="save-search" centered hide-footer hide-header size="md" @hidden="$bvModal.hide('save-search'), resetSearchNameValidations()">
      <div>
        <div class="cs-modal-header">
          <div>Save Search</div>

          <div>
            <img
              class="rotate-on-hover"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt=""
              @click="
                $bvModal.hide('save-search'), resetSearchNameValidations()
              "
            />
          </div>
        </div>
        <div class="cs-modal-body-4 d-flex flex-column justify-content-center">
          <div class="acs-input-head">Search Name</div>
          <div class="position-relative mt-1">
            <b-form-input
              class="cs-laptopinput"
              placeholder="Enter"
              type="text"
              autofocus
              @keydown="showSearchNameExistError = false"
              v-model.trim="$v.saveSearchTitle.$model"
              :class="{
                error: $v.saveSearchTitle.$error || showSearchNameExistError,
              }"
              @keyup.enter="saveSearch()"
            ></b-form-input>
            <div
              class="cv-validationicon"
              v-if="$v.saveSearchTitle.$dirty && !$v.saveSearchTitle.required"
              v-b-popover.hover.top.v-danger="{
                content: 'Required',
              }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <div
              class="cv-validationicon"
              v-if="
                !$v.saveSearchTitle.maxLength && $v.saveSearchTitle.required
              "
              v-b-popover.hover.top.v-danger="{
                content: 'Should not exceed 128 characters',
              }"
              variant="primary"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <div
              v-if="showSearchNameExistError"
              class="errortxt mt-1 position-absolute"
            >
              Search name already exists
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end bluebtn p-3">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            @click="$bvModal.hide('save-search'), resetSearchNameValidations()"
            >Cancel</b-button
          >
          <b-button class="acs-addBtn-modal w-95px" @click="saveSearch"
            >Save</b-button
          >
        </div>
      </div>
    </b-modal>
    <AddtoJDModal
      v-if="showAddToJd"
      :showModal="showAddToJd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @close-modal="(showAddToJd = false), closeAddToJDSuccessMultiple()"
      :isSingle="false"
      :from="'cvSearch'"
    />
    <AddToJDSuceessMultiple
      v-if="showCandTPModal"
      :showCandTPModal="showCandTPModal"
      :from="'cvSearch'"
      :selectedjd="selectedjd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @hide-cand-tp-modal="
        (showCandTPModal = false), closeAddToJDSuccessMultiple()
      "
      @candidates-failed="closeAddToJDSuccessMultiple"
    />
  </div>
</template>

<script>
import {
  searchProfilesSave,
  searchProfiles,
  updatesearchProfiles,
} from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import cvSearch from "../../components/mixin/cvSearch";
import { mapGetters } from "vuex";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import SelectDropdown from "../../components/fixedcomponents/Select.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import AddtoJDModal from "../../controllers/Talentpool/AddtoJDModal.vue";
import AddToJDSuceessMultiple from "../../controllers/Talentpool/AddToJDSuceessMultiple.vue";
import MultiSelectSearch from "../../components/InputComponents/MultiSelectSearch.vue";
import commonFunc from "../../components/mixin/commonFunctions.js";

export default {
  name: "SearchCandidate",
  components: {
    Spinner,
    SelectDropdown,
    MultiSelectSearch,
    AddtoJDModal,
    PageInput,
    AddToJDSuceessMultiple,
  },
  mixins: [toast, cvSearch, commonFunc],
  data() {
    return {
      //loader
      loaderStatus: false,

      //dropdowns
      showKeywordDropdown: false,
      showAddDropdown: false,
      currentContactDropdown: null,

      //modals
      showCandTPModal: false,
      showAddToJd: false,
      saveSearchTitle: null,

      //pagination
      totalPages: 0,
      pageCount: 50,
      pageStart: null,
      pageEnd: null,
      goToPage: null,
      total: 0,
      currentPage: 1,

      //closable fields
      showField: {
        keywords: false,
        experience: false,
        ctc: false,
        location: false,
        noticePeriod: false,
        gender: false,
        age: false,
        workType: false,
        employmentType: false,
        itSkills: false,
        industry: false,
        designation: false,
        education: false,
      },
      showAdvanced: true,

      //search fields
      search: {
        mandatoryKeywords: [],
        keywords: [],
        skills: [],
        location: [],
        preferredLocation: [],
        gender: [],
        workType: [],
        employmentType: [],
        itSkills: [{ skillName: "", yearsOfExp: "", mandatory: false }],
        industry: [],
        designation: [],
        minimumEducation: null,
        experienceTo: null,
        experienceFrom: null,
        salaryFrom: null,
        salaryTo: null,
        ageFrom: null,
        ageTo: null,
        noticePeriod: null,
        activeInDays: null,
        viewProfile: null,
        willingToRelocate: false,
        searchType: "4",
      },

      //others
      isCopied: "",
      selectedProfiles: [],
      selectCand: [],
      profiles: [],
      selectedjd: [],
      isViewing: false,
      currentKeyword: null,
      showSearchNameExistError: false,
      list: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "cvSearch") {
      this.$store.commit("cvSearchVUEX/saveAppliedSearch", {});
    }
    next();
  },
  created() {
    this.loadSearch();
    if (this.$route.query.grid) this.list = this.$route.query.grid !== "true";
    this.searchProfiles();
  },
  methods: {
    clearFilter() {
      this.currentKeyword = null;
      this.resetSearch(false);
      this.searchProfiles();
    },
    updatePageCount(pageCount) {
      this.pageCount = pageCount;
      this.currentPage = 1;
      this.searchProfiles();
    },
    hideAddDropdown() {
      this.showAddDropdown = false;
    },
    loadSearch() {
      if (
        JSON.stringify(this.appliedSearch) !== "{}" &&
        this.appliedSearch.searchID === this.allSearchsaveallsearchData.searchID
      ) {
        this.search = JSON.parse(JSON.stringify(this.appliedSearch));
      } else {
        this.search = JSON.parse(
          JSON.stringify(this.allSearchsaveallsearchData)
        );
      }
      if (this.search?.itSkills.length === 0) {
        this.search.itSkills = [
          { skillName: "", yearsOfExp: "", mandatory: false },
        ];
      }
    },
    goToBookmarked() {
      this.$router.push({
        name: "BookmarkedCandidates",
      });
    },
    resetSearchNameValidations() {
      this.showSearchNameExistError = false;
      this.$v.saveSearchTitle.$reset();
      this.saveSearchTitle = "";
    },
    async updateSearch() {
      try {
        this.currentPage = 1;
        await this.searchProfiles();
        this.loaderStatus = true;

        const res = await updatesearchProfiles({
          ...this.search,
        });
        if (res.status == 200) {
          this.$store.dispatch("cvSearchVUEX/searchProfilesData", this.search);
          this.loadSearch();
          this.successModal("Search updated successfully");
        } else {
          this.errorModal("Failed to update search");
        }
      } catch (error) {
        this.errorModal("Failed to update search");
      }
      this.loaderStatus = false;
    },
    async saveSearch() {
      this.$v.saveSearchTitle.$touch();
      if (!this.$v.saveSearchTitle.$invalid) {
        try {
          let payLoad = {
            ...this.search,
            title: this.saveSearchTitle,
            bookmark: false,
          };
          let res = await searchProfilesSave(payLoad);
          if (res.status == 200) {
            this.successModal("You have saved this search successfully.");
            this.$store.dispatch(
              "cvSearchVUEX/searchProfilesData",
              this.search
            );

            this.search.title = this.saveSearchTitle;
            this.search.searchID = res.data.data.searchID;
            this.$bvModal.hide("save-search");
            this.resetSearchNameValidations();
          } else if (res.status == 409) {
            this.showSearchNameExistError = true;
          } else {
            this.errorModal(res.data.data.Detail);
          }
        } catch (error) {
          this.errorModal("Something went wrong");
          throw new Error(`Failed! saveSearch ! status: ${error.status}`);
        }
      }
    },
    async searchProfiles() {
      this.loaderStatus = true;
      try {
        const res = await searchProfiles({
          ...this.search,
          searchQuery: this.searchQuery,
          page: this.currentPage - 1,
          count: this.pageCount,
        });
        if (res.status == 200) {
          this.profiles = res.data.data.data;
          this.total = res.data.data.total;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.totalPages = Math.ceil(this.total / this.pageCount);
          this.$store.commit("cvSearchVUEX/saveAppliedSearch", this.search);
          this.loadSearch();

          if (document.getElementById("profiles-container") != null) {
            const element = document.getElementById("profiles-container");
            element.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
        } else {
          this.errorModal("Failed to fetch profiles");
        }
      } catch (err) {
        this.errorModal("Failed to fetch profiles");
      }
      this.loaderStatus = false;
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    gobackpointer() {
      this.$router.go(-1);
    },
    viewProfile(profile) {
      this.$router.push({
        name: "ViewCandidateProfile",
        params: {
          email: profile.email,
        },
      });
    },
  },
  computed: {
    isSearchApplied() {
      return JSON.stringify(this.search) === JSON.stringify(this.appliedSearch);
    },
    isSearchSaved() {
      return (
        JSON.stringify(this.search) ===
        JSON.stringify(this.allSearchsaveallsearchData)
      );
    },
    ...mapGetters("cvSearchVUEX", {
      allSearchsaveallsearchData: "getsaveallsearchData",
      appliedSearch: "getAppliedSearch",
      getJobIDs: "getJobIDs",
      whereFrom: "whereFrom",
    }),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters(["roles"]),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.currentPage = 1;
          this.searchProfiles();
        }
      }
    },
    list(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$router.replace({
          name: "SearchCandidate",
          query: {
            grid: !this.list,
          },
        });
      }
    },
  },
};
</script>

<style>
.cv-validationicon {
  position: absolute;
  top: 4px;
  right: 10px;
  background: var(--bg-white);
}
.notice-period-style {
  background: #ffffff;
  border: 1px solid #bfbfbf;
  border-radius: 14px;
  padding: 5px 10px;
  font-weight: 500;
  font-size: 12px;
  color: #72738e;
}

.text-fonts {
  font-weight: 600;
  font-size: 13px;
  color: #333333;
}

.search-candidate-main {
  height: calc(100vh - 150px);
  width: 100%;
}

.view-all-text {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}

.searchcv-rightside-main {
  height: calc(100vh - 250px);
  gap: 15px;
  overflow: auto;
  padding: 10px;
}

.search-candidate-left-container {
  background: #ffffff;
  border-radius: 8px;
  height: 100%;
  padding: 10px 5px 10px 10px;
}

.search-candidate-right-container {
  width: 75%;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  background-color: #ffffff;
}

.candidate-head-texts {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.save-search {
  background: #fcfcfc;
  border: 1px solid #72738e;
  border-radius: 3px;
  font-weight: 500;
  font-size: 13px;
  color: #72738e;
}

.searchcandidate-main-card {
  background: #ffffff;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  width: 440px;
  height: 380px;
  padding: 15px;
}

.profile-img {
  border-radius: 50%;
  background: white;
  height: 70px;
  width: 70px;
  overflow: hidden;
}

.options-text {
  font-weight: 400;
  font-size: 12px;
  color: #595959;
}

.searchcandidate-place-icons {
  position: absolute;
  right: 0;
}

.filter-texts {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.cvsearch-radio-txt {
  font-weight: 400;
  font-size: 12px;
  color: #595959;
}
.search-candidate-main .custom-control-label::before {
  position: absolute;
  top: 4px;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.grey-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  text-decoration-line: underline;
  color: #72738e;
}

.checkbox-round {
  width: 14px;
  height: 14px;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}

.checkbox-round:checked {
  background: #72738e;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
}

.main-card {
  background: #ffffff;
  border-radius: 5px;
  align-items: center;
  width: 100%;
  padding: 10px;
}

.main-card-text {
  font-weight: 700;
  font-size: 14px;
  color: #333333;
}

.cvsearch-top-edit-txt {
  font-weight: 400;
  font-size: 14px;
  color: #696969;
}

.view-profile-text {
  font-weight: 400;
  font-size: 13px;

  color: #333333;
}

.switchParent {
  height: 30px;
  background-color: #ffffff;
  border: 0.67px solid #e9f0f5;
  box-shadow: 0px 1.33px 5.33px 0px #00000040;
  border-radius: 15px;
  width: 56px;
  margin-top: 2px;
  padding: 2px;
}

.searchcv-newclass {
  height: calc(100vh - 265px);
  overflow: auto;
  padding: 10px;
}

.switchChild {
  width: 27px;
  cursor: pointer;
  display: grid;
  place-content: center;
  border-radius: 50%;
}

.maincard-innertexts {
  background: #e6e6e6;
  border-radius: 14px;
  padding: 5px 10px;
  font-weight: 500;
  font-size: 12px;
  color: #72738e;
}

.cand-container-heading {
  font-weight: 400;
  font-size: 16px;
  text-transform: capitalize;
  color: #696969;
}

.vertical {
  border-left: 1px solid grey;
  height: 100px;
}

.view-profile-main-div {
  height: calc(100vh - 260px);
  overflow: auto;
  padding-right: 10px;
}

.text-fonts-one {
  font-weight: 500;
  font-size: 12px;
  color: #72738e;
}

.name-font {
  font-weight: 500;
  font-size: 12px;
  color: #72738e;
}

.sub-font {
  font-weight: 400;
  font-size: 12px;
  color: #72738e;
}

.viewProfile-btn-class {
  font-weight: 600;
  font-size: 14px;
  text-decoration-line: underline;
  color: #72738e;
}

.cvs-wrkexp-years {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.cvs-listview-subtxt {
  font-weight: 400;
  font-size: 13px;
  color: #333333;
}

.cvs-listview-headtext {
  font-weight: 400;
  font-size: 13px;
  color: #696969;
}
.cvinput-addblock-pos {
  position: absolute;
  top: 5px;
  right: 5px;
}

.qb-filter-modal-cv {
  padding: 10px;
  background: #ffffff;
  border: 5px solid rgba(114, 115, 142, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
  z-index: 6;
}

.aoesearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.qb-dd-group {
  width: 100%;
  overflow-y: scroll;
}

.aoeinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.add-panel-name {
  font-size: 14px;
  font-weight: 400;
  color: #545454;
}

.searchCV-paginaTion {
  padding: 5px 10px;
  width: 100%;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
  border-radius: 0px 0px 5px 5px;
  background: #e4e4f2;
}
.SeaCv-block {
  padding: 30px;
  border-radius: 10px;
  background: #f7f9f9;
}
.SeaCv-listBlock {
  padding: 10px;
  border-radius: 10px;
  background: #f7f9f9;
}
.no-margin {
  margin: 0;
}
.searchcv-inputs {
  font-weight: 400;
  font-size: 14px;
  z-index: 1;
  background: #fcfcfc;
  border: 0.5px solid #c4c4c4;
  border-color: #c4c4c4;
  box-shadow: inset 0px 0px 3px rgb(0 0 0 / 25%);
  border-radius: 5px;
  padding: 8px 30px 8px 6px;
}
.highlighted {
  background-color: yellow;
  font-weight: bold;
}
.highlighted-span {
  margin-right: 4px;
}
.cv-clear-all-text {
  font-weight: 600;
  font-size: 13px;
  color: #20639b;
}
</style>
